import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Paper,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
    Modal,
    Button,
  } from "@mui/material";
  import moment from "moment";
  import React, { useEffect, useState } from "react";
  import { getRequest, server } from "../../config";
  import dayjs from "dayjs";
  const PaymentHistory = ({ servingPinCodes }) => {
    const [specificDate, setSpecificDate] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalEarning, settotalEarning] = useState(0);
    const [range, setrange] = useState("");
    const [actualData, setactualData] = useState([]);
    const [contractData, setcontractData] = useState([])
    const [slot, setslot] = useState([
      "Same Range",
      "100-10000",
      "10000-1 lakh",
      "Above 1 lakh",
    ]);
    const computeEarning = (response) => {
      let sum = 0;
      const arraycontract = [];
      response?.map((item) => {
        const price = parseInt(item?.amount);
        let tempprice = 0;
        tempprice=(price*5)/100
        tempprice=(tempprice*40)/100
        arraycontract.push(tempprice);
        sum += tempprice;
      });
      setactualData([...arraycontract]);
      settotalEarning(sum);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    // Handle rows per page change
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0); // Reset to the first page when rows per page changes
    };
    useEffect(() => {
      fetchCustomers();
    }, [page, rowsPerPage, specificDate]);
    const fetchCustomers = async () => {
      try {
        const filter = {
          skip: page * rowsPerPage,
          limit: rowsPerPage,
        };
  
        const response = await getRequest(
          `${server.uri}contracts?filter={
              "where":{"partnerPincode":{"inq":["${servingPinCodes}"]}
             },
            "skip":"${filter.skip}",
              "limit":"${filter.limit}"
      
              ,"order":"createdAt desc","include":[{"relation":"serviceRequest"},{"relation":"partner","scope":{"fields":{"uniqueId":true}}}]}`
        );
        //   console.log(response);
        setCustomers(response);
        setcontractData(response)
        computeEarning(response);
        const responseCount = await getRequest(
          `${server.uri}contracts/count?where={
             "partnerPincode":{"inq":["${servingPinCodes}"]}
              }`
        );
  
        console.log(responseCount);
  
        setTotalCount(responseCount.count);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    const handleChangeStatus=(e)=>{
      const value=e.target.value
      const filter = contractData?.filter(item => item?.range == value);
      setrange(value)
      computeEarning(filter)
      setCustomers(filter)
      
      
    }
    return (
      <Container>
        <Box>
          <FormControl
            variant="outlined"
            sx={{ minWidth: 200, marginRight: "10px" }}
          >
            <InputLabel>Range</InputLabel>
            <Select
              value={range}
              onChange={handleChangeStatus}
              label="City"
              fullWidth
            >
              {/* <MenuItem value="">
                <em>All Cities</em>
              </MenuItem> */}
              {slot.map((city) => (
                <MenuItem key={city} value={city}>
                  {city}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Typography sx={{ textAlign: "right" }} variant="subtitle1" gutterBottom>
          Total Contracts: <strong>{customers?.length}</strong>
        </Typography>
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f4f6f8", // Light background for table header
                  }}
                >
                  <TableCell sx={{ fontWeight: "bold" }}>Customer Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Mobile Number</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>PartnerId</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>BookingId</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Address</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>PinCode</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Estimated Days{" "}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Range</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {" "}
                    Estimated Amount
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    
                   Earning
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customers?.map((customer,index) => (
                  <TableRow
                    sx={{
                      "&:nth-of-type(even)": {
                        backgroundColor: "#f9fafb", // Alternate row color for better readability
                      },
                    }}
                    key={customer.serviceRequestId}
                  >
                    <TableCell sx={{ cursor: "pointer" }}>
                      {customer?.serviceRequest?.customerName}
                    </TableCell>
                    <TableCell>
                      {customer?.serviceRequest?.mobileNumber}
                    </TableCell>
                    <TableCell>
                      {customer?.partner?.uniqueId}
                    </TableCell>
                    <TableCell>{customer?.serviceRequest?.bookingId}</TableCell>
                    <TableCell>{customer?.serviceRequest?.address}</TableCell>
                    <TableCell>{customer?.serviceRequest?.pincode}</TableCell>
  
                    <TableCell>{customer?.estimatedDays}</TableCell>
                    <TableCell>
                      <strong>₹{customer?.range}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>₹{customer?.amount}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>₹{actualData[index]}</strong>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
  
          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25,100,500,1000]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <Typography
            sx={{ textAlign: "right", marginRight: 2 }}
            variant="subtitle1"
            gutterBottom
          >
            Total Earning: <strong>₹ {totalEarning?.toFixed(2)}</strong>
          </Typography>
        </Paper>
      </Container>
    );
  };
  
  export default PaymentHistory;
  